import React from 'react'

import { Select } from '../../common/components/select'
import { selectComponentService } from '../../common/services/select-component.service'

export const DataFieldSelect = function ({ selectedValue, dataFieldOptions, dataKey, label, isRequired, onChange, isDisabled = false }) {
  const options = isRequired ? dataFieldOptions : [ { value: undefined, label: 'None' }, ...dataFieldOptions ]

  return (
    <div className="data-field-select" data-qa={`select-${dataKey}`}>
      <Select
        dataKey={dataKey}
        label={label}
        options={options}
        value={selectComponentService.getSelectedValue(options, selectedValue)}
        message={
          selectComponentService.isKnownField(options, selectedValue)
            ? undefined
            : { type: 'warning', message: 'Field is not in dataset.' }
        }
        size="medium"
        onChange={({ value }) => {
          onChange(dataKey, value)
        }}
        placeholder={isRequired ? 'required' : ''}
        isDisabled={isDisabled}
      />
    </div>
  )
}
